module.exports = __webpack_public_path__ + "static/media/solicitudGrado.83e03ef8.png";